import tailwindConfig from 'tailwind.config'
import resolveConfig from 'tailwindcss/resolveConfig'

export default resolveConfig(tailwindConfig)
